'use client';

import React from 'react';

import { Container } from '@/components/Container';
import { FullArticle } from '@/components/FullArticle/FullArticle';
import { BlogLayout } from '@/components/Layouts/BlogLayout';
import Section from '@/components/Section/Section';
import { ArticlesList } from '@/features/ArticlesList/ArticlesList';
import { Banner } from '@/features/Banner/Banner';
import Blog from '@/features/Blog/Blog';
import { BookDemo } from '@/features/BookDemo/BookDemo';
import { FAQ } from '@/features/FAQ/FAQ';
import { Intro } from '@/features/Intro/Intro';
import { ListItems } from '@/features/ListItems/ListItems';
import { OurReviews } from '@/features/OurReviews/OurReviews';
import { Testimonals } from '@/features/Testimonals/Testimonals';
import {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  industries,
  intro,
  reviews,
  testimonals,
} from '@/lib/industries/fire_safety';

const FireSafety = () => {
  return (
    <>
      <Intro withVideo={false} imageSrc={intro.imageSrc.src} item={intro} />

      <Section>
        <Container>
          <FullArticle item={fullArticle1} />
        </Container>
      </Section>

      <Section>
        <Banner
          title={`Customize your tools, choose your features, `}
          subTitle="Take Control of Your Fire Safety Management Today!"
          secondaryTitle=" and access your operations on any device."
          thirtTitle=""
          listItems={[]}
        />
      </Section>

      <Container>
        <Section title={articles.title}>
          <ArticlesList {...articles} />
        </Section>
      </Container>

      <Section>
        <Container>
          <OurReviews item={reviews} />
        </Container>
      </Section>

      <Section>
        <Container>
          <FullArticle item={fullArticle2} />
        </Container>
      </Section>

      <Section>
        <Banner
          title={`Unlock unparalleled protection with our cutting-edge Free Fire Safety Software, designed specifically for businesses looking to fortify their fire management strategies. `}
          subTitle="Enhance Your Safety with Our Free Fire Safety Software!"
          listItems={[
            { title: 'Free version' },
            { title: 'Onboarding and support' },
            { title: 'Data migration' },
            { title: '24/7 customer service' },
          ]}
        />
      </Section>

      <Section>
        <Container>
          <Testimonals title="Our Testimonials" items={testimonals} />
        </Container>
      </Section>

      <Container>
        <Section title="FAQ">
          <FAQ items={faq} />
        </Section>
      </Container>

      <BlogLayout>
        <Container>
          <Section title={blog.title} description={blog.description}>
            <Blog />
          </Section>
        </Container>
      </BlogLayout>

      <Container>
        <Section title={industries.title} description={industries.description}>
          <ListItems {...industries} />
        </Section>
      </Container>

      <BookDemo {...bookDemo} />
    </>
  );
};

export default FireSafety;
